module.exports = __webpack_public_path__ + "static/media/logo_rodeo.7f0ff4ef.svg";